var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Raf'),_c('transition',{attrs:{"enter-active-class":"animated bounceInLeft","leave-active-class":"animated bounceOutRight"}},[_c('router-view')],1),(_vm.updateExists)?_c('button',{staticClass:"update",on:{"click":_vm.refreshApp}},[_vm._v(" Nouvelle version disponible ! Cliquez pour mettre à jour ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }